<template>
  <div class="Info">
      <div :class="['cmain',{'show':isShow},{'m':isMobile}]">
        <div class="inner">
          <div class="title">南阳市博物馆（渠首博物馆）简介</div>
          <div class="text">
            <p v-for="(txt,i) in text" :key="i">{{txt}}</p>
          </div>
        </div>
          <span :class="['close',{'m':isMobile}]" @click="close"><img src="@/assets/images/close-icon.png" alt=""></span>
      </div>
  </div>
</template>

<script>
import browser from '@/utils/browser.js'
export default {
  name: 'Info',
  props: {
    show: Boolean
  },
  data() {
    return {
      isMobile:browser.mobile,
      isShow:false,
      delay:0,
      text:[
        '南阳市博物馆（渠首博物馆）位于美丽的白河之滨、光武大桥以东，鼎盛大道与白河大道交会处，为原文化部确立的重点文化基础设施工程、南阳厚重历史文化的精品文化工程“三馆一院”之一，是我市重要的文化建筑组群，也是白河国家湿地公园核心区中的现代化标志性文化设施。',
        '南阳市博物馆为国家二级博物馆，2021年1月1日，南阳市博物馆新馆建成启用对外开放，是豫西南最大的地方综合性博物馆、文化新地标、南阳的“城市文化会客厅”，也是展示南阳悠久历史和灿烂文化的重要窗口。',
        '南阳市博物馆馆藏文物丰富，新馆建筑为五层，建筑面积4.6万平方米，馆藏文物5万余件（套），博物馆为综合性展馆、免费开放博物馆。博物馆由公共服务大厅、基本陈展区、专题陈展区、临时展览区、藏品库房、文物修复区、青少年研学区、智慧指挥中心、报告厅、餐厅、咖啡休闲区、文创展示区、办公区等组成。它集文物收藏、陈列展览、宣传教育、科学研究等多功能于一体，配备有先进电脑网络系统、多媒体触摸屏系统、数码式语音导览系统，及同声翻译的多功能厅，可接待多层次的学术会议和多语种的参观团体。',
        '南阳市博物馆基本陈展《文明在宛——南阳历史基本陈列展》，专题展览《古玉撷英——南阳古代玉器精品展》《致敬青铜——南阳青铜器精品展》《陶铸汉威——南阳汉代陶狗展》《渠首遗珍——南水北调中线工程南阳段文物保护成果展》，共展出文物5000余件（套），已经对外开放，年接待游客100余万人次。'

      ]
    }
  },
  methods: {
    close() {
      this.isShow = false;
      var that = this;
       setTimeout(function(){
          that.$emit('close')
        },300)
      //
    }
  },
  watch: {
    show(val) {
      if(val){
        var that = this;
        setTimeout(function(){
          console.log("11")
          that.isShow = true;
        },1)
        
      }
    }
  },
  mounted() {

    
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .Info {
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.2);
    .cmain {
      position:absolute;
      left:0;
      right:0;
      bottom:0;
      top:0;
      margin:auto;
      width:52vw;
      height:31.25vw;
      background:url(../assets/images/pop-bg.png)center/100% 100% no-repeat;
      transform:translateY(-1000%);
      transition:all 0.2s;
      
      &.m {
        width:86.67vw;
        height:70vh;
        background:url(../assets/images/pop-bg2.png)center/100% 100% no-repeat;
        padding:1vw;
        .inner {
          width:100%;
          height: 100%;
          overflow: auto;
        }
        .title {
          font-size:5vw;
        }
        .text {
          padding:0 2vw ;
          p {
            font-size:3.6vw;
            line-height:7vw;
          }
        }
      }
      &.show {
        transform:translateY(0);
      }
      .title {
        font-size:1.25vw;
        text-align:center;
        color:#815d28;
        padding:1.5vw 0 1vw 0;
      }
      .text {
        padding:0 1vw;
        p {
          font-size:1vw;
          text-indent:2em;
          color:#815d28;
          line-height:1.8vw;
        }
      }
      .close {
        position:absolute;
        display:block;
        width:2vw;
        top:-1vw;
        right:-1vw;
        &.m {
          width:8.5vw;
          bottom:-16vw;
          left:0;
          right:0;
          top:auto;
          margin:auto;
        }
      }
      
    }
  }
</style>
